export const tokenAddresses = {
  EUL: "0xB90e23CeF93CA91c1526aAF9742A13A0946E9de4",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0x47296EC1Ec5143640653169D1a6c8C2C387E41A6",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
